// ProfileCard Component
// Wrapper for LinkedIn-style profile sections

import React from 'react';
import styles from './ProfileCard.module.css';

const ProfileCard = ({ 
  title, 
  icon: Icon, 
  children, 
  id,
  isEmpty = false,
  emptyMessage = 'No information added yet.',
  className = ''
}) => {
  return (
    <div className={`${styles.card} ${className}`} id={id}>
      {title && (
        <div className={styles.cardHeader}>
          {Icon && <Icon className={styles.icon} />}
          <h2 className={styles.title}>{title}</h2>
        </div>
      )}
      <div className={styles.cardContent}>
        {isEmpty ? (
          <p className={styles.emptyState}>{emptyMessage}</p>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default ProfileCard;


